/*******************************************************************************
 *** FindPasswd ** 비밀번호 찾기
 *******************************************************************************/
import { useNavigate } from 'react-router-dom';
import React from 'react';
import Util from '../common/Util';
import AppContext from '../common/AppContext';

function FindPasswd() {
    const navigate = useNavigate();

    const [windowWidth, setWindowWidth] = React.useState<number>(window.innerWidth);

    React.useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const isMobile = windowWidth <= 768;
    const pageSidePadding = isMobile ? 16 : 24;
    const cardWidth = Math.min(600, windowWidth - (pageSidePadding * 2));
    const buttonWidth = Math.min(cardWidth - (isMobile ? 32 : 40), Math.floor(cardWidth * 0.8));

    return (
        <div
            className='w100p dpFlx flxdCol aiC jcC'
            style={{
                minHeight: "100dvh",
                backgroundColor: "#f6f7f9",
                boxSizing: "border-box",
                paddingLeft: pageSidePadding,
                paddingRight: pageSidePadding,
                paddingTop: isMobile ? 20 : 24,
                paddingBottom: isMobile ? 20 : 24
            }}
        >
            <div
                className="bgcWhite bsOut bsBdb"
                style={{
                    width: cardWidth,
                    borderRadius: 10,
                    boxSizing: "border-box",
                    padding: isMobile ? "28px 16px 32px 16px" : "40px 20px 50px 20px"
                }}
            >
                <div className='w100p dpFlx aiC jcC'>
                    <img
                        src={Util.getImgSrc("common/logo.png")}
                        width={isMobile ? 170 : 238}
                        height={isMobile ? 58 : 81}
                        alt="logo"
                    />
                </div>

                <div
                    className='w100p dpFlx aiC jcC'
                    style={{
                        paddingTop: isMobile ? 28 : 40,
                        paddingBottom: isMobile ? 24 : 40
                    }}
                >
                    <span
                        className="fcBlack fw700"
                        style={{
                            fontSize: isMobile ? 30 : 40,
                            letterSpacing: -1,
                            marginLeft: 0,
                            textAlign: "center",
                            lineHeight: 1.2
                        }}
                    >
                        비밀번호 찾기
                    </span>
                </div>

                <div
                    className='w100p dpFlx aiC jcC'
                    style={{
                        paddingLeft: isMobile ? 4 : 12,
                        paddingRight: isMobile ? 4 : 12
                    }}
                >
                    <p
                        className='Pretendard-Medium taC'
                        style={{
                            fontSize: isMobile ? 17 : 20,
                            letterSpacing: -0.5,
                            fontWeight: 500,
                            color: "#2C2C2C",
                            lineHeight: isMobile ? "30px" : "40px",
                            margin: 0,
                            wordBreak: "keep-all"
                        }}
                    >
                        비밀번호 찾기 기능은 관리자 문의를 통해 진행됩니다.
                        <br />
                        <span className='fc666666 fwB'>조합본부 관리자</span>에게 연락하여 안내를 받으시기 바랍니다.
                    </p>
                </div>

                <div
                    className='dpFlx jcC aiC'
                    style={{
                        marginTop: isMobile ? 32 : 50
                    }}
                >
                    <button
                        type="button"
                        className='dpFlx aiC jcC csP'
                        style={{
                            width: buttonWidth,
                            height: isMobile ? 54 : 62,
                            backgroundColor: AppContext.themeColor,
                            borderRadius: 10,
                            border: "none",
                            outline: "none"
                        }}
                        onClick={() => navigate('/portal/login')}
                    >
                        <span
                            className="Pretendard-Bold fcWhite"
                            style={{
                                fontSize: isMobile ? 18 : 20,
                                letterSpacing: 0
                            }}
                        >
                            확인
                        </span>
                    </button>
                </div>
            </div>
        </div>
    );
}

export default FindPasswd;